import React from 'react';
import { cn } from '@/lib/utils';

export interface EquationValueBadgeProps {
  label: string;
  value: string;
  tone?: 'primary' | 'muted';
  className?: string;
}

export function EquationValueBadge({
  label,
  value,
  tone = 'primary',
  className,
}: EquationValueBadgeProps) {
  return (
    <div className={cn('min-w-[72px] text-center', className)}>
      <div className="h-[12px] font-label text-[10px] sm:text-[12px] leading-none uppercase tracking-[1.1px] text-muted-foreground mb-1 flex items-center justify-center">
        {label}
      </div>
      <div
        className={cn(
          'w-full h-8 flex items-center justify-center font-mono text-[15px] font-semibold',
          tone === 'primary'
            ? 'text-primary-text'
            : 'text-foreground/80',
        )}
      >
        {value}
      </div>
    </div>
  );
}
